import styled, { css, keyframes } from 'styled-components';

// Pisca por ~1,2s no início do ciclo e fica apagado no restante (pausa)
const piscarAtraso = (ciclo) => {
  const pct = (segundos) => `${((segundos / ciclo) * 100).toFixed(4)}%`;
  return keyframes`
    0% { opacity: 0; }
    ${pct(0.2)}, ${pct(0.9)} { opacity: 1; }
    ${pct(1.2)}, 100% { opacity: 0; }
  `;
};

export const Page = styled.div`
  min-height: 100vh;
  background: #f3f6fb;
  color: #1f2937;
`;

export const Content = styled.main`
  margin-left: 0;
  padding: 80px 24px 40px;

  @media (max-width: 768px) {
    margin-left: 0;
    padding-top: 90px;
  }
`;

export const BotaoVoltar = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 42px;
  padding: 0 12px;
  border: 1px solid #2563eb;
  border-radius: 8px;
  background: #ffffff;
  color: #2563eb;
  cursor: pointer;

  &:hover {
    background: #eff6ff;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  gap: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const Title = styled.h1`
  margin: 0;
  font-size: clamp(1.6rem, 2vw, 2.2rem);
  color: #111827;
`;

export const BotaoNotas = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  margin-top: 14px;
  border: 1px solid #2563eb;
  border-radius: 8px;
  background: #ffffff;
  color: #2563eb;
  cursor: pointer;

  &:hover {
    background: #eff6ff;
  }
`;

export const Subtitle = styled.p`
  margin: 8px 0 0;
  color: #6b7280;
  font-size: 0.95rem;
`;

export const Board = styled.div`
  display: grid;
  grid-template-columns: repeat(6, minmax(180px, 1fr));
  gap: 16px;
  align-items: start;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(3, minmax(180px, 1fr));
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const Column = styled.section`
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.04);
  overflow: hidden;
  min-height: 420px;
`;

export const ColumnHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  background: ${props => props.accent || '#2d6cdf'};
  color: #ffffff;
  font-size: 0.95rem;
  font-weight: 700;
`;

export const ColumnTitleGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const ColumnTotal = styled.span`
  color: rgba(255, 255, 255, 0.82);
  font-size: 0.72rem;
  font-weight: 600;
`;

export const Counter = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 28px;
  padding: 0 8px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.18);
  color: #ffffff;
  font-size: 0.8rem;
`;

export const FilterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px 0;
  background: #ffffff;
  overflow-x: auto;
  white-space: nowrap;

  &::-webkit-scrollbar {
    height: 4px;
  }
`;

export const FilterButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${props => (props.active ? props.accent : '#d1d5db')};
  background: ${props => (props.active ? `${props.accent}1a` : '#f9fafb')};
  color: ${props => (props.active ? props.accent : '#374151')};
  border-radius: 999px;
  padding: 5px 10px;
  font-size: 0.68rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
    border-color: #d1d5db;
    color: #9ca3af;
    background: #f3f4f6;
  }

  &:not(:disabled):hover {
    border-color: ${props => props.accent};
    background: ${props => `${props.accent}12`};
  }
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 14px;
  min-height: 340px;
`;

export const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 160px;
  border: 1px dashed #d1d5db;
  border-radius: 12px;
  background: #f9fafb;
  color: #9ca3af;
  font-size: 0.9rem;
`;

export const Card = styled.article`
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-left: 4px solid ${props => props.accent || '#2d6cdf'};
  border-radius: 12px;
  padding: 12px;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.03);
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  ${props => props.overdue && css`
    position: relative;

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: inherit;
      background: rgba(235, 115, 115, 0.75);
      box-shadow: inset 0 0 0 1px #dc2626;
      pointer-events: none;
      opacity: 0;
      ${props.blinkDelay != null && css`
        animation: ${piscarAtraso(props.blinkDelay.ciclo)} ${props.blinkDelay.ciclo}s linear infinite;
        animation-delay: ${props.blinkDelay.atraso}s;
      `}
    }
  `}

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 22px rgba(15, 23, 42, 0.08);
  }
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
`;

export const CardActions = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

export const CardCode = styled.span`
  font-size: 0.78rem;
  font-weight: 700;
  color: #374151;
`;

export const CardBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  border-radius: 999px;
  border: 1px solid ${props => `${props.accent || '#2d6cdf'}50`};
  background: ${props => `${props.accent || '#2d6cdf'}15`};
  color: ${props => props.statusAccent || props.accent || '#2d6cdf'};
  font-size: 0.7rem;
  font-weight: 700;
`;

export const TaskButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 1px solid ${props => `${props.accent || '#2d6cdf'}66`};
  border-radius: 6px;
  background: #ffffff;
  color: ${props => props.accent || '#2d6cdf'};
  cursor: pointer;

  &:hover {
    background: ${props => `${props.accent || '#2d6cdf'}12`};
  }
`;

export const FileLink = styled.a`
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 8px;
  padding: 8px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  color: #374151;
  text-decoration: none;
  background: #ffffff;

  &:hover {
    background: #f8fafc;
    border-color: #93c5fd;
  }
`;

export const FileGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
  gap: 12px;
`;

export const FilePreview = styled.div`
  display: flex;
  width: 100%;
  height: 100px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 6px;
  background: #f3f4f6;

  img,
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const FilePreviewFallback = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  color: #4b5563;
  font-size: 0.65rem;
  font-weight: 700;
`;

export const FileName = styled.span`
  width: 100%;
  overflow: hidden;
  color: #374151;
  font-size: 0.75rem;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const CardTitle = styled.h3`
  margin: 0 0 8px;
  font-size: 1rem;
  color: #111827;
`;

export const CardMetaRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin: 4px 0;
`;

export const CardMeta = styled.p`
  margin: 0;
  color: #4b5563;
  font-size: 0.8rem;
`;

export const RotuloPendente = styled.span`
  color: #b45309;
  font-weight: 700;
`;

export const EmptyColumn = styled.div`
  background: transparent;
  min-height: 420px;
  border: 1px dashed transparent;
  border-radius: 16px;
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.55);
  z-index: 1000;
  padding: 16px;
`;

export const ModalCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 460px;
  max-height: 90vh;
  overflow: hidden;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.25);

  .lista {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 12px;
  }

  .titulo {
    font-size: 0.8rem;
    font-weight: 700;
    color: #374151;
  }

  input {
    border: 1px solid #d1d5db;
    border-radius: 8px;
    padding: 8px 10px;
    font-size: 0.9rem;
    outline: 0;

    &:focus {
      border-color: #2d6cdf;
    }
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  padding: 16px 20px;
  border-bottom: 1px solid #e5e7eb;
  font-weight: 700;
  color: #111827;

  button {
    border: none;
    background: transparent;
    font-size: 1.3rem;
    line-height: 1;
    cursor: pointer;
    color: #6b7280;
  }
`;

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 20px;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid #e5e7eb;

  button {
    border: none;
    border-radius: 8px;
    padding: 9px 16px;
    font-size: 0.85rem;
    font-weight: 700;
    cursor: pointer;
  }

  button:first-child {
    background: #f3f4f6;
    color: #374151;
  }

  button:last-child {
    background: #2d6cdf;
    color: #ffffff;

    &:disabled {
      background: #93c5fd;
      cursor: not-allowed;
    }
  }

  @media (max-width: 768px) {
    padding: 12px 14px;

    button {
      padding: 9px 12px;
    }
  }
`;

export const TarefasDia = styled.div`
  background: #fffdf2;
  border: 1px solid #e8dfbd;
  border-radius: 8px;
  padding: 16px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8);
`;

export const DiasNotas = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 16px;
`;

export const DiaNota = styled.button`
  position: relative;
  width: 32px;
  height: 30px;
  border: 1px solid ${props => (props.selecionado ? '#2563eb' : '#d1d5db')};
  border-radius: 6px;
  background: ${props => (props.selecionado ? '#2563eb' : '#ffffff')};
  color: ${props => (props.selecionado ? '#ffffff' : '#374151')};
  font-size: 0.76rem;
  font-weight: 700;
  cursor: pointer;

  &:hover {
    border-color: #2563eb;
  }
`;

export const IndicadorTarefa = styled.span`
  position: absolute;
  top: -3px;
  right: -3px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ef4444;
  border: 1px solid #ffffff;
`;

export const BotaoTodasTarefas = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 30px;
  border: 1px solid ${props => (props.selecionado ? '#2563eb' : '#d1d5db')};
  border-radius: 6px;
  background: ${props => (props.selecionado ? '#2563eb' : '#ffffff')};
  color: ${props => (props.selecionado ? '#ffffff' : '#374151')};
  cursor: pointer;

  &:hover {
    border-color: #2563eb;
  }
`;

export const BotaoConcluidas = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  align-self: flex-start;
  margin-bottom: 10px;
  border: 1px solid ${props => (props.selecionado ? '#16a34a' : '#d1d5db')};
  border-radius: 999px;
  padding: 5px 12px;
  background: ${props => (props.selecionado ? '#16a34a1a' : '#ffffff')};
  color: ${props => (props.selecionado ? '#16a34a' : '#374151')};
  font-size: 0.76rem;
  font-weight: 700;
  cursor: pointer;

  &:hover {
    border-color: #16a34a;
  }
`;

export const LinhaTarefa = styled.form`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;

  input[type="date"] {
    flex: 0 0 auto;
    width: 150px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    padding: 9px 10px;
    outline: 0;
    background: #ffffff;

    &:focus {
      border-color: #2563eb;
    }
  }

  button {
    border: 0;
    border-radius: 6px;
    padding: 0 16px;
    height: 38px;
    background: #16a34a;
    color: #ffffff;
    font-weight: 700;
    cursor: pointer;

    &:disabled {
      background: #86efac;
      cursor: not-allowed;
    }
  }
`;

export const CampoComDica = styled.div`
  position: relative;
  flex: 1;
  min-width: 160px;

  input {
    width: 100%;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    padding: 9px 10px;
    outline: 0;
    background: #ffffff;
    position: relative;

    &:focus {
      border-color: #2563eb;
    }
  }
`;

export const TextoFantasma = styled.span`
  position: absolute;
  top: 0;
  padding: 9px 0;
  color: #9ca3af;
  white-space: pre;
  pointer-events: none;
  font: inherit;
`;

export const TextoMedidor = styled.span`
  position: absolute;
  visibility: hidden;
  white-space: pre;
  font: inherit;
`;

export const BotaoIconeData = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  border: 1px solid ${props => (props.ativo ? '#2563eb' : '#d1d5db')};
  border-radius: 6px;
  background: ${props => (props.ativo ? '#eff6ff' : '#ffffff')};
  color: ${props => (props.ativo ? '#2563eb' : '#6b7280')};
  cursor: pointer;

  &:hover {
    border-color: #2563eb;
    color: #2563eb;
  }
`;

export const ListaEventos = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
`;


export const EventoSelecionavel = styled.button`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 3px;
  width: 100%;
  border: 1px solid ${props => (props.selecionado ? '#2563eb' : '#d1d5db')};
  border-radius: 6px;
  padding: 9px 10px;
  background: ${props => (props.selecionado ? '#eff6ff' : '#ffffff')};
  color: #374151;
  text-align: left;
  cursor: pointer;

  strong {
    color: #111827;
  }

  small {
    color: #6b7280;
  }
`;

export const AvisoNotas = styled.p`
  margin: 0 0 12px;
  color: #6b7280;
  font-size: 0.85rem;
  display: flex;
  justify-content: space-between;
`;

export const ListaTarefas = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-height: 80px;
  padding: 4px 0 12px;
`;

export const Tarefa = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  padding-bottom: 8px;
  border-bottom: 1px dashed #e8dfbd;
  color: #453f2d;
  font-size: 0.92rem;
  cursor: pointer;

  input {
    width: 16px;
    height: 16px;
    accent-color: #2563eb;
  }

  span {
    text-decoration: ${props => (props.concluida ? 'line-through' : 'none')};
    color: ${props => (props.concluida ? '#16a34a' : 'inherit')};
    opacity: ${props => (props.concluida ? 0.75 : 1)};
  }

  small {
    color: #6b7280;
    font-size: 0.72rem;
  }
`;

export const BotaoTema = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  margin-left: auto;
  border: 1px solid #2563eb;
  border-radius: 8px;
  background: #ffffff;
  color: #2563eb;
  cursor: pointer;

  &:hover {
    background: #eff6ff;
  }

  @media (max-width: 768px) {
    position: absolute;
    top: 80px;
    right: 24px;
  }
`;

export const TemaEscuro = styled.div`
  min-height: 100vh;
  background: #0f172a;
  color: #e5e7eb;

  ${Title} { color: #f9fafb; }
  ${Subtitle} { color: #9ca3af; }
  ${BotaoVoltar}, ${BotaoNotas}, ${BotaoTema} {
    background: #1e293b;
    border-color: #3b82f6;
    color: #93c5fd;
    &:hover { background: #334155; }
  }
  ${Column} {
    background: #1e293b;
    border-color: #3b5f91;
    box-shadow: none;
  }
  ${FilterRow} {
    background: #1e293b;
  }
  ${Card} {
    background: #334155;
    border-top-color: #475569;
    border-right-color: #475569;
    border-bottom-color: #475569;
  }
  ${CardCode}, ${CardTitle} { color: #f8fafc; }
  ${CardMeta}, ${FileName} { color: #cbd5e1; }
  ${ColumnTotal}, ${FileName} { 
    color: #ffffff; 
  }
  ${EmptyState}, ${EmptyColumn} {
    background: #0f172a;
    border-color: #475569;
    color: #94a3b8;
  }
`;
